var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"w-full h-full min-h-700px"},[_c('iframe',{staticClass:"w-full h-full",style:(_setup.iframeStyle),attrs:{"src":_setup.iframeSrc,"frameborder":"0","allow":"microphone"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }